export default "__VITE_ASSET__Bbs8GKQ3__"